import { useEffect, useState } from 'react';
import { requestLoginCode, verifyLoginCode } from './api';
import { LOGIN_EMAIL_KEY } from './LoginEmailPage';

const onlyDigits = (s) => (s || '').replace(/\D/g, '').slice(0, 6);

export default function LoginCodePage() {
  const [email] = useState(() => {
    try { return sessionStorage.getItem(LOGIN_EMAIL_KEY) || ''; } catch { return ''; }
  });
  const [code, setCode] = useState('');
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);
  const [resent, setResent] = useState(false);

  // No email stashed (deep-link / refresh that cleared storage) → back to start.
  useEffect(() => {
    if (!email) window.location.hash = '#/login';
  }, [email]);

  if (!email) return null;

  const submit = async () => {
    setErr('');
    if (code.length !== 6) { setErr('Enter the 6-digit code'); return; }
    setLoading(true);
    try {
      const res = await verifyLoginCode(email, code);
      try { sessionStorage.removeItem(LOGIN_EMAIL_KEY); } catch { /* ignore */ }
      window.location.hash = '#/portal/' + encodeURIComponent(res.token);
    } catch (e) {
      setErr(e.message || 'That code is incorrect or has expired.');
    } finally {
      setLoading(false);
    }
  };

  const resend = async () => {
    setErr('');
    setResent(false);
    try {
      await requestLoginCode(email);
    } catch {
      // Neutral on failure — anti-enumeration; offer the same reassurance.
    } finally {
      setResent(true);
      setTimeout(() => setResent(false), 4000);
    }
  };

  return (
    <div className="wrap">
      <div className="brand">VANTAGE · Referral Portal</div>
      <h1 className="title">Enter your code</h1>
      <p className="lead">
        If <b>{email}</b> is a registered referrer, we've sent a 6-digit code. Enter it below to log in.
      </p>

      {resent && <div className="banner-ok">If that email is a registered referrer, we've sent a new code.</div>}

      <div className="card">
        <h2>6-digit code</h2>
        <div className="form-field">
          <label>Code<span className="req"> *</span></label>
          <input
            type="text"
            inputMode="numeric"
            autoComplete="one-time-code"
            maxLength={6}
            value={code}
            onChange={(e) => { setCode(onlyDigits(e.target.value)); setErr(''); }}
            onKeyDown={(e) => { if (e.key === 'Enter') submit(); }}
            placeholder="123456"
          />
          {err && <div className="form-err">{err}</div>}
        </div>
      </div>

      <button className="primary-cta" onClick={submit} disabled={loading}>
        {loading ? 'Logging in…' : 'Log in'}
      </button>

      <p className="lead" style={{ marginTop: 18, textAlign: 'center' }}>
        Didn't get it? <a href="#/login/code" onClick={(e) => { e.preventDefault(); resend(); }}>Resend code</a>
        {' · '}
        <a href="#/login">Use a different email</a>
      </p>
    </div>
  );
}
